/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Perk_Groups_BodyInputs */



/**
* | output |
* | --- |
* | "XP boosts for boosters or supporters, channel access, passes and more, tied to a role." |
*
* @param {Features_Perk_Groups_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_perk_groups_body = /** @type {((inputs?: Features_Perk_Groups_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Perk_Groups_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Множители XP для бустеров или спонсоров, доступ к каналам, зачёт уровня и многое другое — с привязкой к роли.")
	return /** @type {LocalizedString} */ ("XP boosts for boosters or supporters, channel access, passes and more, tied to a role.")
});